/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Loading_Project_InfoInputs */

const en_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading project info...`)
};

const fr_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des informations du projet...`)
};

const de_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektinformationen werden geladen...`)
};

const it_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento informazioni sul progetto...`)
};

const ru_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка информации о проекте...`)
};

const es_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando información del proyecto...`)
};

const zh_cn2_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载项目信息...`)
};

const ja_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト情報を読み込んでいます...`)
};

const hi_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट की जानकारी लोड हो रही है...`)
};

const pt_pt2_work_order_import_status_loading_project_info = /** @type {(inputs: Work_Order_Import_Status_Loading_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando informações do projeto...`)
};

/**
* | output |
* | --- |
* | "Loading project info..." |
*
* @param {Work_Order_Import_Status_Loading_Project_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_loading_project_info = /** @type {((inputs?: Work_Order_Import_Status_Loading_Project_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Loading_Project_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_loading_project_info(inputs)
	if (locale === "de") return de_work_order_import_status_loading_project_info(inputs)
	if (locale === "it") return it_work_order_import_status_loading_project_info(inputs)
	if (locale === "ru") return ru_work_order_import_status_loading_project_info(inputs)
	if (locale === "es") return es_work_order_import_status_loading_project_info(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_loading_project_info(inputs)
	if (locale === "ja") return ja_work_order_import_status_loading_project_info(inputs)
	if (locale === "hi") return hi_work_order_import_status_loading_project_info(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_loading_project_info(inputs)
	return en_work_order_import_status_loading_project_info(inputs)
});